import { IoMdAttach } from 'react-icons/io'
import {
  formatDate,
  formatDateTime,
  formatDateFromISO,
  formatTime
} from '../utils/FormateDateTime'
import {
  FaCalendarCheck,
  FaCloudDownloadAlt,
  FaHandshake,
  FaHeart,
  FaInfoCircle,
  FaMoneyBill,
  FaPlay,
  FaWeight
} from 'react-icons/fa'
import {
  MdAir,
  MdOutlineLocalHospital,
  MdOutlineReportProblem,
  MdWorkOff
} from 'react-icons/md'
import { IoTimeOutline } from 'react-icons/io5'
import { LuTestTubeDiagonal } from 'react-icons/lu'
import { ImSad } from 'react-icons/im'
import { sequenceTableTemplate } from '../utils/squenceTableNo'
import ProgressNotesEditor from '../components/his/patient-profile/ProgessNotesEditor'
import { extractTextFromHTML } from '../utils/ExtractTextFromHtml'
import { Checkbox } from 'primereact/checkbox'
import CustomChip from '../shared/CustomChip'
import { href } from 'react-router-dom'
import { formatDuration } from '../utils/FormateDuration'
import { FaShield } from 'react-icons/fa6'

export const vitalSignReason = {
  'vital-sign-height': [{ id: '999.9', name: 'Not Measured' }],
  'vital-sign-weight': [{ id: '999.9', name: 'Not Collected' }],
  'vital-sign-systolic': [
    { id: '888', name: 'Not measurable' },
    { id: '999', name: 'Unknown' }
  ],
  'vital-sign-diastolic': [
    { id: '888', name: 'Not measurable' },
    { id: '999', name: 'Unknown' }
  ],
  'vital-sign-temperature': [
    { id: '88', name: 'Not Obtained' },
    { id: '99', name: 'Unknown' }
  ],
  'vital-sign-pulse': [
    { id: '997', name: 'Cardiac Arrest' },
    { id: '998', name: 'Not Recorded' },
    { id: '999', name: 'Not Stated' }
  ],
  'vital-sign-respiratory-rate': [
    { id: '00', name: 'Artificial Ventilation' },
    { id: '88', name: 'Not Obtained' },
    { id: '99', name: 'Unknown' }
  ],
  'vital-sign-oxygen-saturation': [
    { id: '888', name: 'Not Obtained' },
    { id: '999', name: 'Unknown' }
  ],
  'vital-sign-SP02': [
    { id: '88', name: 'Not Obtained' },
    { id: '99', name: 'Unknown' }
  ],
  'vital-sign-pain-score': [
    { id: '88', name: 'Not Obtained' },
    { id: '99', name: 'Unknown' }
  ],
  'vital-sign-RBS': [
    { id: '88', name: 'Not Obtained' },
    { id: '99', name: 'Unknown' }
  ],
  'vital-sign-bmi': [{ id: 'NA', name: 'Not Calculated' }],
  'duration-of-illness': [{ id: '99', name: 'Unknown' }]
}

export const allergyToleranceColunms = t => [
  {
    field: 'type',
    header: t('Allergy Type'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'category',
    header: t('Category'),
    headerCellClass: '!bg-gray-200'
  },
  {
    body: row => {
      return formatDateTime(row?.onsetDateTime)
    },
    header: t('Date of Onset'),
    headerCellClass: '!bg-gray-200'
  },
  {
    body: row => {
      const val = row?.recordedDate
      if (!val) return ''
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
        const [y, m, d] = val.split('-').map(Number)
        return '\u200E' + `${String(d).padStart(2, '0')} ${months[m - 1]} ${y}`
      }
      const dt = new Date(val)
      if (isNaN(dt.getTime())) return ''
      return (
        '\u200E' +
        `${String(dt.getDate()).padStart(2, '0')} ${months[dt.getMonth()]
        } ${dt.getFullYear()}`
      )
    },
    header: t('Recorded Date'),
    headerCellClass: '!bg-gray-200'
  }
]
export const allergyToleranceCategories = [
  { value: 'food', label: 'Food' },
  { value: 'drug', label: 'Drug' },
  { value: 'environmental', label: 'Environmental' }
]

export const accidentTypes = [
  { value: 'Motor Vehicle Accident', label: 'Motor Vehicle Accident' },
  { value: 'School Accident', label: 'School Accident' },
  { value: 'Sporting Accident', label: 'Sporting Accident' },
  { value: 'Workplace Accident', label: 'Workplace Accident' }
]

export const statusOptions = [
  { value: 'Completed', label: 'Completed' },
  { value: 'Pending', label: 'Pending' }
]

export const accidentColumns = t => [
  {
    field: 'accident_type',
    header: t('Accident Type'),
    headerCellClass: '!bg-gray-200'
  },
  { field: 'street', header: t('Street'), headerCellClass: '!bg-gray-200' },
  { field: 'city', header: t('City'), headerCellClass: '!bg-gray-200' },
  { field: 'country', header: t('Country'), headerCellClass: '!bg-gray-200' },
  {
    body: row => {
      return formatDate(row?.date)
    },
    header: t('Date'),
    headerCellClass: '!bg-gray-200'
  }
]

export const immunizationColumns = t => [
  {
    field: 'vaccine_code',
    header: t('Vaccine Code'),
    headerCellClass: '!bg-gray-200'
  },
  { field: 'status', header: t('Status'), headerCellClass: '!bg-gray-200' },
  {
    header: t('Date'),
    headerCellClass: '!bg-gray-200',
    body: row => {
      return formatDateTime(row?.occurrenceDateTime)
    }
  }
]

export const encounterColumns = t => [
  {
    field: 'encounterStatus',
    header: t('Encounter Status'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'encounterClass',
    header: t('Encounter Class'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'serviceType',
    header: t('Service Type'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'serviceEventType',
    header: t('Service Event Type'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'encounterPriority',
    header: t('Encounter Priority'),
    headerCellClass: '!bg-gray-200'
  },
  {
    body: row => {
      return formatDate(row?.periodStart)
    },
    header: t('Period Start'),
    headerCellClass: '!bg-gray-200'
  },
  {
    body: row => {
      return formatDate(row?.periodEnd)
    },
    header: t('Period End'),
    headerCellClass: '!bg-gray-200'
  }
  // {
  //   field: 'emergencyArivalCode',
  //   header: 'Emergency Arrival Code',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'emergencyServiceDate',
  //   header: 'Emergency Service Date',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'emergencyDepartmentDisposition',
  //   header: 'Emergency Department Disposition',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'triageCategory',
  //   header: 'Triage Category',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'triageDate',
  //   header: 'Triage Date',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'adminSource',
  //   header: 'Admin Source',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'readmission',
  //   header: 'Readmission',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'dischargeDisposition',
  //   header: 'Discharge Disposition',
  //   headerCellClass: '!bg-gray-200'
  // },
  // {
  //   field: 'intendedLengthOfStay',
  //   header: 'Intended Length of Stay',
  //   headerCellClass: '!bg-gray-200'
  // }
]

export const supportingInfoHeaders = [
  'category',
  'value',
  'code_text',
  'start_date',
  'end_date'
]

export const fomrateSupportingInfoData = supportInfoData => {
  return supportInfoData?.map(data => {
    let category = data?.category
    let value = data?.image_content_type
      ? data?.image_value
      : data?.value || data?.code
    let type = data?.image_content_type ? 'img' : ''
    let code_text = data?.code_text || '--'
    let start_date = data?.start_date || '--'
    let end_date = data?.end_date || '--'

    return {
      category,
      value,
      code_text,
      type,
      start_date,
      end_date
    }
  })
}

export const immunizationHeader = ['Code', 'Status', 'Date']

export const formatmmunizationData = immunizationData => {
  return immunizationData?.map(data => {
    let Code = data?.vaccine_code
    let Status = data?.status
    let Date = formatDateTime(data?.occurrenceDateTime)

    return {
      Code,
      Status,
      Date
    }
  })
}

export const supportingInfoElements = [
  {
    label: 'Attachment',
    id: 2,
    name: 'Attachment',
    icon: <IoMdAttach size={17} className='text-gray-500' />,
    object: {
      category: 'attachment',
      attachment_name: '',
      attachment_type: '',
      image_value: '',
      image_title: '',
      image_content_type: ''
    }
  },
  // {
  //   label: 'Birth Weight',
  //   id: 3,
  //   name: 'Birth Weight',
  //   icon: <FaWeight size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'birth-weight',
  //     value: '',
  //     valueUnit: 'kg'
  //   }
  // },
  {
    label: 'Days Supply',
    id: 4,
    name: 'Days Supply',
    icon: <FaCalendarCheck size={17} className='text-gray-500' />,
    object: {
      category: 'days-supply',
      valueUnit: 'd',
      value: ''
    }
  },
  {
    label: 'Employment Impacted',
    id: 5,
    name: 'Employment Impacted',
    icon: <MdWorkOff size={17} className='text-gray-500' />,
    object: {
      category: 'employment-impacted',
      start_date: '',
      end_date: ''
    }
  },
  // {
  //   label: 'Hospitalized',
  //   id: 6,
  //   name: 'Hospitalized',
  //   icon: <MdOutlineLocalHospital size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'hospitalized',
  //     start_date: '',
  //     end_date: ''
  //   }
  // },
  // {
  //   label: 'ICU Hours',
  //   id: 7,
  //   name: 'ICU Hours',
  //   icon: <IoTimeOutline size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'icu-hours',
  //     start_date: '',
  //     end_date: '',
  //     value: '',
  //     valueUnit: 'h'
  //   }
  // },
  {
    label: 'Info',
    id: 8,
    name: 'Info',
    icon: <FaInfoCircle size={17} className='text-gray-500' />,
    object: {
      category: 'info',
      value: '',
      valueUnit: ''
    }
  },
  {
    label: 'Lab Test',
    id: 9,
    name: 'Lab Test',
    icon: <LuTestTubeDiagonal size={17} className='text-gray-500' />,
    object: {
      category: 'lab-test',
      start_date: '',
      end_date: '',
      value: '',
      valueUnit: '',
      code_text: '',
      code: ''
    }
  },
  {
    label: 'Last Menstrual Period',
    id: 10,
    name: 'Last Menstrual Period',
    icon: <FaCalendarCheck size={17} className='text-gray-500' />,
    object: {
      category: 'last-menstrual-period',
      start_date: ''
    }
  },
  {
    label: 'Tooth Number',
    id: 11,
    name: 'Missing Tooth',
    icon: <ImSad size={17} className='text-gray-500' />,
    object: {
      category: 'missingtooth',
      start_date: '',
      code_text: '',
      code: '',
      reason: ''
    }
  },
  // {
  //   label: 'Onset',
  //   id: 12,
  //   name: 'Onset',
  //   icon: <FaPlay size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'onset',
  //     start_date: '',
  //     code_text: '',
  //     code: ''
  //   }
  // },
  {
    label: 'Oxygen Saturation',
    id: 13,
    name: 'Oxygen Saturation',
    icon: <FaHeart size={17} className='text-gray-500' />,
    object: {
      category: 'oxygen-saturation',
      start_date: '',
      end_date: '',
      value: '',
      valueUnit: '%'
    }
  },
  // {
  //   label: 'Reason For Visit',
  //   id: 15,
  //   name: 'Reason For Visit',
  //   icon: <FaCalendarCheck size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'reason-for-visit',
  //     code_text: '',
  //     code: ''
  //   }
  // },
  // {
  //   label: 'Ventilation Hours',
  //   id: 18,
  //   name: 'Ventilation Hours',
  //   icon: <MdAir size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'ventilation-hours',
  //     start_date: '',
  //     end_date: '',
  //     value: '',
  //     valueUnit: 'h'
  //   }
  // },

  // {
  //   id: 23,
  //   name: 'History of Present Illness',
  //   label: 'History of Present Illness',
  //   icon: <FaInfoCircle size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'history-of-present-illness',
  //     value: null,
  //     valueUnit: ''
  //   }
  // },
  // {
  //   id: 24,
  //   name: 'Past Medical & Surgical Historys',
  //   label: 'Past Medical & Surgical Historys',
  //   icon: <FaInfoCircle size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'patient-history',
  //     value: null,
  //     valueUnit: ''
  //   }
  // },
  // {
  //   id: 25,
  //   name: 'Physical Examination',
  //   label: 'Physical Examination',
  //   icon: <FaInfoCircle size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'physical-examination',
  //     value: null,
  //     valueUnit: ''
  //   }
  // },
  // {
  //   id: 26,
  //   name: 'Treatment Plan',
  //   label: 'Treatment Plan',
  //   icon: <FaInfoCircle size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'treatment-plan',
  //     value: null,
  //     valueUnit: ''
  //   }
  // },
  // {
  //   id: 27,
  //   name: 'Estimated Length of Stay',
  //   label: 'Estimated Length of Stay',
  //   icon: <FaInfoCircle size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'estimated-Length-of-Stay',
  //     value: null,
  //     valueUnit: 'd'
  //   }
  // },
  {
    id: 28,
    name: 'Morphology',
    label: 'Morphology',
    icon: <MdOutlineReportProblem size={17} className='text-gray-500' />,
    object: {
      category: 'morphology',
      code_text: '',
      code: ''
    }
  },
  {
    id: 29,
    name: 'Investigation Result',
    label: 'Investigation Result',
    icon: <ImSad size={17} className='text-gray-500' />,
    object: {
      category: 'investigation-result',
      code_text: '',
      code: '',
      image_value: '',
      image_title: '',
      image_content_type: ''
    }
  }
  // {
  //   id: 30,
  //   name: 'Admission Weight',
  //   label: 'Admission Weight',
  //   icon: <FaWeight size={17} className='text-gray-500' />,
  //   object: {
  //     category: 'admission-weight',
  //     value: null,
  //     valueUnit: 'kg'
  //   }
  // }
]

export const supoortingInfotableHeaders = t => [
  {
    name: t('No')
  },
  {
    name: t('Category')
  },
  {
    name: t('Code')
  },
  {
    name: t('time')
  },
  {
    name: t('value')
  },
  {
    name: t('Attachment')
  },
  {
    name: t('Reason')
  },
  {
    name: t('Actions')
  }
]

export const missingToothReasons = [
  { value: 'extraction', label: 'Extraction' },
  { value: 'congenital', label: 'Congenital' },
  { value: 'unknown', label: 'Unknown' },
  { value: 'other', label: 'Other' }
]

export const investigationResult = [
  {
    value: 'IRA',
    label: 'Investigation results attached'
  },
  {
    value: 'INP',
    label: 'Investigation(s)not performed'
  },
  {
    value: 'IRP',
    label: 'Investigation results pending'
  },
  { value: 'NA', label: 'Not applicable or Other' }
]

export const itemstableColumns = (t, price_list_types, i18n) => [
  {
    body: sequenceTableTemplate,
    header: t('No.'),
    headerCellClass: '!bg-gray-300',
    bodyCellClass: `${i18n.language === 'en' ? 'text-left' : 'text-right'}`
  },
  {
    field: 'item_type',
    header: t('ItemType'),
    body: row => row?.selected_category,
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'item_category',
    header: t('Item Category'),
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'non_standard_code',
    header: t('Non Standard Code'),
    headerCellClass: '!bg-gray-300',
    body: row => row?.non_standard_code || row?.standard_code || '-'
  },
  {
    field: 'non_standard_description',
    header: t('Non Standard Description'),
    headerCellClass: '!bg-gray-300',
    body: rowData => {
      const desc =
        i18n.language === 'en'
          ? rowData?.non_standard_description ||
          rowData?.item_name ||
          rowData?.standard_description
          : rowData?.non_standard_description_ar ||
          rowData?.item_name ||
          rowData?.standard_description_ar
      return desc || '--'
    }
  },
  {
    field: 'quantity',
    header: t('Quantity'),
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'unit_price',
    header: t('UnitPrice'),
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'days_supply',
    header: t('Days Supply'),
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'is_approval',
    header: t('Approval Required'),
    body: row => <Checkbox checked={row?.is_approval} />,
    headerCellClass: '!bg-gray-300'
  }
]

export const itemstableColumnsTrack = (t, i18n) => [
  {
    field: 'item_category',
    header: t('Item Category'),
    headerCellClass: '!bg-gray-300',
    body: row => (
      <>
        {row?.item_category === 'cash' ? 'Cash' : 'Insurance'}
        {row?.is_nahdi_pharmacy && (
          <FaHandshake
            size={18}
            className='inline ml-2 text-blue'
            title='third party'
          />
        )}
      </>
    )
  },
  {
    field: 'non_standard_code',
    header: t('Code'),
    headerCellClass: '!bg-gray-300',
    body: row => row?.non_standard_code || row?.standard_code || '-'
  },
  {
    field: 'non_standard_description',
    header: t('Desc.'),
    headerCellClass: '!bg-gray-300',
    body: rowData => {
      const desc =
        i18n.language === 'en'
          ? rowData?.non_standard_description ||
          rowData?.item_name ||
          rowData?.standard_description
          : rowData?.non_standard_description_ar ||
          rowData?.item_name ||
          rowData?.standard_description_ar
      return desc || '--'
    }
  },
  {
    field: 'quantity',
    header: t('Qty'),
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'selected_category',
    header: t('Cat.'),
    headerCellClass: '!bg-gray-300'
  },
  // {
  //   field: 'item_category',
  //   header: t('itm.c'),
  //   headerCellClass: '!bg-gray-300',
  // },
  {
    field: 'unit_price',
    header: t('U.P'),
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'gross_amount',
    header: t('G.A'),
    headerCellClass: '!bg-gray-300',
    body: row =>
      (
        Number(Number(row?.unit_price || 0) * Number(row?.quantity || 0)) || 0
      ).toFixed(2)
  },
  {
    field: 'discount_amount',
    header: t('Disc.'),
    headerCellClass: '!bg-gray-300',
    body: row => {
      const gross = Number(row?.unit_price || 0) * Number(row?.quantity || 0)
      const discount = Number(row?.discount_amount || 0)
      const value =
        row?.discount_type === 'percentage'
          ? (gross * discount) / 100
          : discount
      return (Number(value) || 0).toFixed(2)
    }
  },
  {
    header: t('P.Share'),
    headerCellClass: '!bg-gray-300',
    body: row => {
      return (Number(row?.patientShareAmount) || 0).toFixed(2)
    }
  },
  {
    header: t('P.Vat'),
    headerCellClass: '!bg-gray-300',
    body: row => {
      return (Number(row?.patient_tax_amount) || 0).toFixed(2)
    }
  },
  {
    header: t('P.Net'),
    headerCellClass: '!bg-gray-300',
    body: row => {
      return (Number(row?.patient_share_with_vat) || 0).toFixed(2)
    }
  },
  // {
  //   field: 'patientShareAmount',
  //   header: t('P.S'),
  //   headerCellClass: '!bg-gray-300',
  //   body: row => (Number(row?.patient_share || row?.patientShareAmount) || 0).toFixed(2)
  // },
  // {
  //   field: 'patient_tax_amount',
  //   header: t('VAT'),
  //   headerCellClass: '!bg-gray-300',
  //   body: row => (Number(row?.patient_tax_amount) || 0).toFixed(2)
  // },
  // {
  //   field: 'patient_share_with_vat',
  //   header: t('Total'),
  //   headerCellClass: '!bg-gray-300',
  //   body: row => (Number(row?.patient_share_with_vat || row?.patient_share || (row?.net_payable_amount)) || 0).toFixed(2)
  // },
  {
    field: 'created_at',
    header: t('Time'),
    headerCellClass: '!bg-gray-300',
    body: row => (
      <div>
        <div>{row?.created_at ? formatDate(row?.created_at) : '-'}</div>
        <div>{row?.created_at ? formatTime(row?.created_at) : '-'}</div>
      </div>
    )
  },

  //   {
  //     field: 'billing_status',
  //     header: t('Bill.'),
  //     headerCellClass: '!bg-gray-300',
  //     body: row => {
  //       const isPaid =
  //         row?.status?.toLowerCase() === "paid" ||
  //         row?.cash_invoice_number ||
  //         row?.pharmacy_invoice_number ||
  //         row?.insurance_invoice_number ||
  //         row?.government_invoice_number ||
  //         row?.corporate_invoice_number||
  //         row?.invoice_numbers?.cash_invoice_number||
  //         row?.invoice_numbers?.pharmacy_invoice_number ||
  //         row?.invoice_numbers?.insurance_invoice_number ||
  //         row?.invoice_numbers?.government_invoice_number ||
  //         row?.invoice_numbers?.corporate_invoice_number;
  //       const isCancelled = row?.status?.toLowerCase() === "cancelled";

  //       const statusText = isPaid
  //         ? "PAID"
  //         : row?.status?.toUpperCase();

  //       return (
  //       <span className="font-semibold">
  //   <span
  //     className={
  //       isCancelled
  //         ? "text-red-800 flex flex-row items-center"
  //         : isPaid
  //         ? "text-success flex flex-row items-center"
  //         : "flex flex-row items-center"
  //     }
  //   >
  //     {statusText} -
  //     <div className='flex flex-col'>
  //       <div>
  //         {row?.updated_at ? formatDate(row.updated_at) : ""}
  //       </div>
  //       <div>
  //         {row?.created_at ? formatTime(row.updated_at) : ""}
  //       </div>
  //     </div>
  //   </span>
  // </span>
  //       );
  //     }
  //   },
  {
    field: 'approval_status',
    header: t('Appr.'),
    body: row => {
      const status = row?.is_approval ? row?.approval_status?.toLowerCase() : null
      const isPending = status === 'pending'
      return (
        <span className='flex items-center gap-1'>
          <span
            className={
              isPending
                ? 'font-semibold text-orange-500'
                : status === 'approved'
                  ? 'font-semibold text-green-600'
                  : 'text-gray-500'
            }
          >
            {row?.is_approval ? row?.approval_status?.toUpperCase() : 'Not Req'}
          </span>
          {row?.approval_reason && (
            <span className='relative group/tooltip'>
              <FaInfoCircle
                size={13}
                className='text-orange-400 cursor-help flex-shrink-0'
              />
              <span className='absolute z-50 hidden group-hover/tooltip:block bottom-full left-1/2 -translate-x-1/2 mb-1 w-72 whitespace-normal break-words rounded bg-gray-800 p-2 text-xs text-white shadow-lg'>
                {row.approval_reason.split(', ').map((reason, i) => (
                  <span key={i} className='block'>
                    {i + 1}. {reason}
                  </span>
                ))}
              </span>
            </span>
          )}
        </span>
      )
    },
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'consumed_at',
    header: t('Consumed At'),
    body: row => (
      <>
        {' '}
        <div>{row?.consumed_at ? formatDate(row?.consumed_at) : '-'}</div>{' '}
        <div>{row?.consumed_at ? formatTime(row?.consumed_at) : '-'}</div>
      </>
    ),
    headerCellClass: '!bg-gray-300'
  },
  {
    field: 'consumed_by',
    header: t('Given By'),
    body: row => row?.consumed_by?.name || '-',
    headerCellClass: '!bg-gray-300'
  },
  // {
  //   field: 'approval_status',
  //   header: t('Appr.'),
  //   body: row => (
  //     <span>
  //       {row?.is_approval ? row?.approval_status?.toUpperCase() : 'Not Req'}{' '}
  //     </span>
  //   ),
  //   headerCellClass: '!bg-gray-300'
  // },
  {
    field: 'invoice_no',
    header: t('Inv.'),
    headerCellClass: '!bg-gray-300',
    body: row =>
      row?.cash_invoice_number || row?.pharmacy_invoice_number ? (
        <CustomChip
          label={row?.cash_invoice_number || row?.pharmacy_invoice_number}
          chipType='blue'
          size='small'
          className='h-[25px] cursor-pointer rounded-md'
        />
      ) : (
        row?.invoice_numbers?.cash_invoice_number && (
          <CustomChip
            label={row?.invoice_numbers?.cash_invoice_number}
            chipType='blue'
            size='small'
            className='h-[25px] cursor-pointer rounded-md'
          />
        )
      )
  }
  // {
  //   field: 'result_status',
  //   header: t('Result Status and Time'),
  //   headerCellClass: '!bg-gray-300'
  // }
]
export const encounterStatus = [
  { id: 'planned', name: 'Planned' },
  { id: 'arrived', name: 'Arrived' },
  { id: 'triaged', name: 'Triaged' },
  { id: 'in-progress', name: 'In Progress' },
  { id: 'onleave', name: 'On Leave' }
]

export const serviceEventType = [
  {
    id: 'ICSE',
    name: 'Initial client service event'
  },
  {
    id: 'SCSE',
    name: 'Subsequent client service event'
  }
]

export const serviceTypes = [
  { id: 'acute-care', name: 'Acute Care' },
  { id: 'sub-acute-care', name: 'Sub-Acute Care' },
  { id: 'rehabilitation', name: 'Rehabilitation' },
  { id: 'mental-behavioral', name: 'Mental & Behavioral' },
  { id: 'geriatric-care', name: 'Geriatric Care' }
]

export const adminSources = [
  { id: 'IA', name: 'IA - Immediate Admission' },
  {
    id: 'EER',
    name: 'EER - Admission from hospital ER'
  },
  {
    id: 'EOP',
    name: 'EOP - Emergency Admission from hospital outpatient'
  },
  {
    id: 'EGPHC',
    name: 'EGPHC - Emergency Admission by referral from government primary healthcare center'
  },
  {
    id: 'EGGH',
    name: 'EGGH - Emergency Admission by referral from general government hospital'
  },
  {
    id: 'EPPHC',
    name: 'EPPHC - Emergency Admission by referral from private primary healthcare center'
  },
  {
    id: 'EPH',
    name: 'EPH - Emergency Admission by referral from private hospital'
  },
  {
    id: 'EIC',
    name: 'EIC - Emergency Admission by insurance company'
  },
  {
    id: 'EWGS',
    name: 'EWGS - Elective waiting list admission government free Scheme'
  },
  {
    id: 'EWSS',
    name: 'EWSS - Elective waiting list admission self-payment Scheme'
  },
  {
    id: 'EWIS',
    name: 'EWIS - Elective waiting list admission insurance coverage Scheme'
  },
  {
    id: 'EMBA',
    name: 'EMBA - Emergency Maternity Birth Admission'
  },
  {
    id: 'PMBA',
    name: 'PMBA - Planned Maternity Birth Admission'
  },
  { id: 'Others', name: 'Others' }
]

export const dischargeDispositions = [
  { id: 'acute-hospital', name: 'Discharge/transfer to an Acute Hospital' },
  { id: 'SDTC', name: 'Statistical Discharge-Type Change' },
  { id: 'SDFL', name: 'Statistical discharge from leave' },
  { id: 'home', name: 'Home/Other' },
  {
    id: 'DTRAS',
    name: 'Discharge /Transfer to a Residential Ageing Service'
  },
  { id: 'DTPH', name: 'Discharge/Transfer to a Psychiatric Hospital' },
  {
    id: 'DTOHA',
    name: 'Discharge /Transfer to Other Health Care Accommodation'
  },
  { id: 'LAMA', name: 'Left Against Medical Advice' },
  { id: 'died', name: 'Died' },
  { id: 'in-hospital', name: 'Patient still in hospital' }
]

export const emergencyArivalCode = [
  { id: 'GEMSA', name: 'Ground EMS Ambulance' },
  { id: 'MOHA', name: 'Ground MOH Ambulance' },
  { id: 'GCDA', name: 'Ground Civil Defense Ambulance' },

  { id: 'GMA', name: 'Ground Military Ambulance' },
  { id: 'GPA', name: 'Ground Private Ambulance' },
  { id: 'EMSAA', name: 'EMS Air Ambulance' },
  { id: 'ACDA', name: 'Air Civil Défense Ambulance' },
  { id: 'AMA', name: 'Air Military Ambulance' },
  { id: 'PV', name: 'Police Vehicle' },
  { id: 'OGV', name: 'Other Government Vehicles' },
  { id: 'PV', name: 'Personal Vehicle' },
  { id: 'other', name: 'Other' },
  { id: 'unknown', name: 'Not stated/unknown' }
]

export const emergencyDepartmentDisposition = [
  { id: 'AH', name: 'Admitted to this hospital' },
  {
    id: 'NAD',
    name: 'Non-admitted patient ED episode completed-departed'
  },
  {
    id: 'NAR',
    name: 'Non-admitted patient ED episode completed-referred'
  },
  { id: 'DNW', name: 'Did Not Wait' },
  { id: 'LAOR', name: 'Left at Own Risk' },
  { id: 'DED', name: 'Died in ED' },
  { id: 'DOA', name: 'Dead on Arrival' },
  { id: 'R', name: 'Registered' }
]

export const triageCategory = [
  { id: 'IR', name: 'Immediate resuscitation' },
  { id: 'VU', name: 'Very Urgent' },
  { id: 'U', name: 'Urgent' },
  { id: 'SER', name: 'Standard ER' },
  { id: 'NU', name: 'Non-Urgent' }
]

export const intendedLengthOfStays = [
  { id: 'ISD', name: 'Intended same day' },
  { id: 'IO', name: 'Intended overnight' },
  { id: '1D', name: '1 day' },
  { id: '2D', name: '2 days' },
  { id: '3D', name: '3 days' },
  { id: '4D', name: '4 days' },
  { id: '5D', name: '5 days' },
  { id: '6D', name: '6 days' },
  { id: '7D', name: '7 days' },
  { id: '1W', name: '1 week' },
  { id: '2W', name: '2 weeks' },
  { id: '3W', name: '3 weeks' },
  { id: '1M', name: '1 month' }
]

export const reAdmission = [{ id: 'R', name: 'Re-Admission' }]

export const dentalItems = [
  { value: '11', label: 'UPPER RIGHT; PERMANENT TEETH # 1' },
  { value: '12', label: 'UPPER RIGHT; PERMANENT TEETH # 2' },
  { value: '13', label: 'UPPER RIGHT; PERMANENT TEETH # 3' },
  { value: '14', label: 'UPPER RIGHT; PERMANENT TEETH # 4' },
  { value: '15', label: 'UPPER RIGHT; PERMANENT TEETH # 5' },
  { value: '16', label: 'UPPER RIGHT; PERMANENT TEETH # 6' },
  { value: '17', label: 'UPPER RIGHT; PERMANENT TEETH # 7' },
  { value: '18', label: 'UPPER RIGHT; PERMANENT TEETH # 8' },
  { value: '21', label: 'UPPER LEFT; PERMANENT TEETH # 1' },
  { value: '22', label: 'UPPER LEFT; PERMANENT TEETH # 2' },
  { value: '23', label: 'UPPER LEFT; PERMANENT TEETH # 3' },
  { value: '24', label: 'UPPER LEFT; PERMANENT TEETH # 4' },
  { value: '25', label: 'UPPER LEFT; PERMANENT TEETH # 5' },
  { value: '26', label: 'UPPER LEFT; PERMANENT TEETH # 6' },
  { value: '27', label: 'UPPER LEFT; PERMANENT TEETH # 7' },
  { value: '28', label: 'UPPER LEFT; PERMANENT TEETH # 8' },
  { value: '31', label: 'LOWER LEFT; PERMANENT TEETH # 1' },
  { value: '32', label: 'LOWER LEFT; PERMANENT TEETH # 2' },
  { value: '33', label: 'LOWER LEFT; PERMANENT TEETH # 3' },
  { value: '34', label: 'LOWER LEFT; PERMANENT TEETH # 4' },
  { value: '35', label: 'LOWER LEFT; PERMANENT TEETH # 5' },
  { value: '36', label: 'LOWER LEFT; PERMANENT TEETH # 6' },
  { value: '37', label: 'LOWER LEFT; PERMANENT TEETH # 7' },
  { value: '38', label: 'LOWER LEFT; PERMANENT TEETH # 8' },
  { value: '41', label: 'LOWER RIGHT; PERMANENT TEETH # 1' },
  { value: '42', label: 'LOWER RIGHT; PERMANENT TEETH # 2' },
  { value: '43', label: 'LOWER RIGHT; PERMANENT TEETH # 3' },
  { value: '44', label: 'LOWER RIGHT; PERMANENT TEETH # 4' },
  { value: '45', label: 'LOWER RIGHT; PERMANENT TEETH # 5' },
  { value: '46', label: 'LOWER RIGHT; PERMANENT TEETH # 6' },
  { value: '47', label: 'LOWER RIGHT; PERMANENT TEETH # 7' },
  { value: '48', label: 'LOWER RIGHT; PERMANENT TEETH # 8' },
  { value: '51', label: 'UPPER RIGHT; DECIDUOUS TEETH # 1' },
  { value: '52', label: 'UPPER RIGHT; DECIDUOUS TEETH # 2' },
  { value: '53', label: 'UPPER RIGHT; DECIDUOUS TEETH # 3' },
  { value: '54', label: 'UPPER RIGHT; DECIDUOUS TEETH # 4' },
  { value: '55', label: 'UPPER RIGHT; DECIDUOUS TEETH # 5' },
  { value: '61', label: 'UPPER LEFT; DECIDUOUS TEETH # 1' },
  { value: '62', label: 'UPPER LEFT; DECIDUOUS TEETH # 2' },
  { value: '63', label: 'UPPER LEFT; DECIDUOUS TEETH # 3' },
  { value: '64', label: 'UPPER LEFT; DECIDUOUS TEETH # 4' },
  { value: '65', label: 'UPPER LEFT; DECIDUOUS TEETH # 5' },
  { value: '71', label: 'LOWER LEFT; DECIDUOUS TEETH # 1' },
  { value: '72', label: 'LOWER LEFT; DECIDUOUS TEETH # 2' },
  { value: '73', label: 'LOWER LEFT; DECIDUOUS TEETH # 3' },
  { value: '74', label: 'LOWER LEFT; DECIDUOUS TEETH # 4' },
  { value: '75', label: 'LOWER LEFT; DECIDUOUS TEETH # 5' },
  { value: '81', label: 'LOWER RIGHT; DECIDUOUS TEETH # 1' },
  { value: '82', label: 'LOWER RIGHT; DECIDUOUS TEETH # 2' },
  { value: '83', label: 'LOWER RIGHT; DECIDUOUS TEETH # 3' },
  { value: '84', label: 'LOWER RIGHT; DECIDUOUS TEETH # 4' },
  { value: '85', label: 'LOWER RIGHT; DECIDUOUS TEETH # 5' }
]

export const priorities = [
  { id: 'EL', name: 'Elective' },
  { id: 'EM', name: 'Emergency' }
]

export const admissionType = [
  { id: 'package', name: 'Package' },
  { id: 'open', name: 'Open' },
  { id: 'nicu', name: 'NICU' },
  { id: 'observation', name: 'Observation' },
  { id: 'other', name: 'Other' }
]

export const relationshipOptions = [
  { value: 'self', label: 'Self' },
  { value: 'spouse', label: 'Spouse' },
  { value: 'parent', label: 'Parent' },
  { value: 'child', label: 'Child' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'grandparent', label: 'Grandparent' },
  { value: 'grandchild', label: 'Grandchild' },
  { value: 'aunt', label: 'Aunt' },
  { value: 'uncle', label: 'Uncle' },
  { value: 'cousin', label: 'Cousin' },
  { value: 'friend', label: 'Friend' },
  { value: 'other', label: 'Other' }
]

export const diagnosisTypes = [
  { value: 'principal', label: 'Principal Diagnosis' },
  { value: 'secondary', label: 'Secondary Diagnosis' },
  { value: 'admitting', label: 'Admitting Diagnosis' },
  { value: 'discharge', label: 'Discharge Diagnosis' },
  { value: 'differential', label: 'Differential Diagnosis' }
]

export const onAdmissionOptions = [
  {
    label: 'Yes',
    value: 'true'
  },
  {
    label: 'No',
    value: 'false'
  }
]

export const diagnosesOptionsFormat = response => {
  return response?.map(data => {
    return {
      label: data?.ascii_description + ' ' + `(${data?.code_id})`,
      value: data?.code_id,
      data: data
    }
  })
}

export const baseClasses = [
  { id: 'AMB', name: 'Ambulatory' },
  { id: 'EMER', name: 'Emergency' },
  { id: 'HH', name: 'Home Health' },
  { id: 'IMP', name: 'Inpatient Encounter' },
  { id: 'SS', name: 'Short Stay' },
  { id: 'FLD', name: 'Field Care' },
  { id: 'OBSENC', name: 'Observation' },
  { id: 'PREV', name: 'Pre-admission' },
  { id: 'VR', name: 'Virtual' },
  { id: 'OTH', name: 'Other Encounters' }
]

export const itemTypeOptions = [
  { value: 'medical-devices', label: 'Medical Devices' },
  { value: 'medication-codes', label: 'Medication Codes' },
  { value: 'transportation-srca', label: 'Transportation SRCA' },
  { value: 'imaging', label: 'Imaging' },
  { value: 'services', label: 'Services' },
  { value: 'laboratory', label: 'Laboratory' },
  { value: 'oral-health-op', label: 'Oral Health OP' },
  { value: 'procedures', label: 'Procedures' }
]
export const body_siteitems = [
  { value: 'E1', label: 'Upper left, eyelvalue' },
  { value: 'E2', label: 'Lower left, eyelvalue' },
  { value: 'E3', label: 'Upper right, eyelvalue' },
  { value: 'E4', label: 'Lower right, eyelvalue' },
  { value: 'F1', label: 'Left hand, second digit' },
  { value: 'F2', label: 'Left hand, third digit' },
  { value: 'F3', label: 'Left hand, fourth digit' },
  { value: 'F4', label: 'Left hand, fifth digit' },
  { value: 'F5', label: 'Right hand, thumb' },
  { value: 'F6', label: 'Right hand, second digit' },
  { value: 'F7', label: 'Right hand, third digit' },
  { value: 'F8', label: 'Right hand, fourth digit' },
  { value: 'F9', label: 'Right hand, fifth digit' },
  { value: 'FA', label: 'Left hand, thumb' },
  {
    value: 'LC',
    label: 'Left circumflex coronary artery'
  },
  {
    value: 'LD',
    label: 'Left anterior descending coronary artery'
  },
  { value: 'LM', label: 'Left main coronary artery' },
  {
    value: 'LT',
    label:
      'Left svaluee (used to valueentify procedures performed on the left svaluee of the body)'
  },
  { value: 'RC', label: 'Right coronary artery' },
  {
    value: 'RI',
    label: 'Ramus intermedius coronary artery'
  },
  {
    value: 'RT',
    label:
      'Right svaluee (used to valueentify procedures performed on the right svaluee of the body)'
  },
  { value: 'T1', label: 'Left foot, second digit' },
  { value: 'T2', label: 'Left foot, third digit' },
  { value: 'T3', label: 'Left foot, fourth digit' },
  { value: 'T4', label: 'Left foot, fifth digit' },
  { value: 'T5', label: 'Right foot, great toe' },
  { value: 'T6', label: 'Right foot, second digit' },
  { value: 'T7', label: 'Right foot, third digit' },
  { value: 'T8', label: 'Right foot, fourth digit' },
  { value: 'T9', label: 'Right foot, fifth digit' },
  { value: 'TA', label: 'Left foot, great toe' },
  { value: 'RIV', label: 'right eye' },
  { value: 'LIV', label: 'left eye' }
]

export const subSites = [
  { value: 'Right', label: 'Right' },
  { value: 'Left', label: 'Left' },
  { value: 'Upper', label: 'Upper' },
  { value: 'Down', label: 'Down' },
  { value: 'Anterior', label: 'Anterior' },
  { value: 'Posterior', label: 'Posterior' },
  { value: 'Interior', label: 'Interior' },
  { value: 'Exterior', label: 'Exterior' }
]

export const medSelectionReasons = [
  { value: 'Generic', label: 'Generic' },
  { value: 'patient-request', label: 'patient-request' },
  { value: 'innovative-noGeneric', label: 'innovative-noGeneric' },
  { value: 'physician-approval', label: 'physician-approval' },
  { value: 'physician-no-approval', label: 'physician-no-approval' },
  { value: 'drug-pharmacyUnavailable', label: 'drug-pharmacyUnavailable' },
  { value: 'drug-nationallyUnavailable', label: 'drug-nationallyUnavailable' },
  { value: 'Irreplaceable', label: 'Irreplaceable' }
]

export const isPackageOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
]

export const dentalSubSites = [
  { value: 'M', label: 'Mesial' },
  { value: 'O', label: 'Occlusal' },
  { value: 'I', label: 'Incisal' },
  { value: 'D', label: 'Distal' },
  { value: 'B', label: 'Buccal' },
  { value: 'V', label: 'Ventral' },
  { value: 'L', label: 'Lingual' },
  { value: 'MO', label: 'Mesioclusal' },
  { value: 'DO', label: 'Distoclusal' },
  { value: 'DI', label: 'Distoincisal' },
  { value: 'MOD', label: 'Mesioclusodistal' }
]

export const diagnosisOptions = diagnosis => {
  return diagnosis?.map((data, index) => {
    return {
      ...data,
      name: data.codeDescription,
      id: index + 1,
      label: data.codeDescription,
      value: index + 1
    }
  })
}

export const careTeamsOptions = careTeams => {
  return careTeams?.map((data, index) => {
    return {
      ...data,
      name: data.practitionerName,
      id: index + 1,
      label: data.practitionerName,
      value: index + 1
    }
  })
}

export const frequencyOptionsFormat = response => {
  return response?.map((data, index) => {
    return {
      label: data.name,
      value: data?.abbreviation
    }
  })
}

export const routeOptionsFormat = response => {
  return response?.map((data, index) => {
    return {
      label: data.name,
      value: data?.id
    }
  })
}

export const supportingInfoOptions = supportingInfos => {
  return supportingInfos?.map((data, index) => {
    return {
      ...data,
      name: data.category,
      id: index + 1,
      label: data?.category === 'morphology'
        ? `${data?.code || ''}${data?.code_text ? ` - ${data.code_text}` : ''}`
        : `${data.category}${data?.category === 'missingtooth'
          ? `(${data?.code_text || data?.codeText})`
          : ''
          }`,
      value: index + 1
    }
  })
}

export const formateItemsArrayOptions = (values, list, type) => {
  let formatedList =
    type == 'careTeam'
      ? careTeamsOptions(list)
      : type == 'diagnosis'
        ? diagnosisOptions(list)
        : supportingInfoOptions(list)
  return formatedList?.filter(data => values?.includes(data?.value))
}

export const claimGenerationColumns = (t, i18n) => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' }
  },
  {
    body: row => {
      return formatDate(row?.visit_date)
    },
    header: t('Visit Date')
  },
  {
    field: 'visit_id',
    header: t('visitId')
  },
  // {
  //   field: 'episode_id',
  //   header: t('episodeId')
  // },
  {
    field: 'episode_type',
    header: t('episode_type')
  },
  {
    body: row => {
      return row?.reference_invoice_number?.map(inv => (
        <div>
          {inv?.insurance_invoice_number ||
            inv?.corporate_invoice_number ||
            inv?.government_invoice_number}
        </div>
      ))
    },
    header: t('invoice_no')
  },
  { field: 'patient.full_name', header: t('PatientName') },
  {
    header: t('Practitioner'),
    body: row => {
      return row?.practitioner?.name
    }
  },
  {
    header: t('Department'),
    body: row => {
      return row?.practitioner?.department?.name_en
    }
  },
  {
    header: t('Payer'),
    body: row => {
      return row?.patient?.selected_plan?.payer_name
    }
  },
  // {
  //   header: t('Type'),
  //   body: row => {
  //     return row?.patient?.Plan?.[0]?.payer?.type
  //   }
  // },
  {
    header: t('Status'),
    body: row => {
      return (
        <CustomChip
          label={row?.claim_status || 'Un Processed'}
          className='h-[22px]'
          chipType={
            row?.claim_status === 'submitted'
              ? 'success'
              : row?.claim_status === 'pending'
                ? 'warning'
                : 'default'
          }
        />
      )
    }
  }
]

export const EmrHistoryTableColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' }
  },
  {
    body: row => {
      return formatDateTime(row?.created_at)
    },
    header: t('created_at')
  },
  { field: 'patient.full_name', header: t('PatientName') },
  {
    header: t('DoctorName'),
    body: row => {
      return row?.careTeamsArr?.[0]?.practitionerName
    }
  },
  // {
  //   body: row => {
  //     return row?.careTeamsArr?.[0]?.care_team_role
  //   },
  //   header: t('care_team_role')
  // },
  // {
  //   body: row => {
  //     return row?.medical_assessments?.chief_complaints?.code
  //   },
  //   header: t('Cheif Complain')
  // },
  {
    body: row =>
      row?.diagnosisArr?.map((dg, index) => (
        <div key={index}>
          {dg.codeDescription +
            (index < row?.diagnosisArr?.length - 1 ? '  , ' : '')}
        </div>
      )),
    header: t('Diagnosis')
  }
  // {
  //   body: row => {
  //     return extractTextFromHTML(row?.doctor_notes?.progress_notes)
  //   },
  //   header: t('Progress Notes'),
  //   bodyCellClass: '!w-[250px] !whitespace-normal'
  // },
  // {
  //   body: row => {
  //     return extractTextFromHTML(row?.doctor_notes?.consult_notes)
  //   },
  //   header: t('Consult Notes'),
  //   bodyCellClass: '!w-[250px] !whitespace-normal'
  // }
]

export const CareTeamsColumnsData = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' },
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'practitionerName',
    header: t('Name'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'care_team_role',
    header: t('Role'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'qualification',
    header: t('qualification'),
    headerCellClass: '!bg-gray-200'
  }
]

export const supportInfoValues = entry =>
  entry
    ?.map(data => {
      const excludedCategories = [
        'vital-sign-systolic',
        'vital-sign-diastolic',
        'vital-sign-height',
        'vital-sign-weight',
        'vital-sign-respiratory-rate',
        'temperature',
        'pulse',
        'SP02',
        'RBS',
        'pain-score'
      ]
      if (excludedCategories.includes(data?.category)) {
        return undefined
      }

      let attachmentData = {
        image_value: data?.image_value,
        image_content_type: data?.image_content_type,
        image_title: data?.image_title
      }
      return {
        category: data?.category ?? null,
        code: data?.code ?? null,
        value: data?.value ?? null,
        image_data: data?.image_value ? attachmentData : null
      }
    })
    .filter(item => item !== undefined)

export const vitalSignsValues = entry => {
  const includedCategories = [
    'vital-sign-systolic',
    'vital-sign-diastolic',
    'vital-sign-height',
    'vital-sign-weight',
    'vital-sign-respiratory-rate',
    'vital-sign-temperature',
    'vital-sign-pulse',
    'vital-sign-SP02',
    'vital-sign-RBS',
    'vital-sign-pain-score',
    'duration-of-illness'
  ]

  return entry
    ?.map(data => {
      if (includedCategories.includes(data?.category)) {
        return {
          [data.category]:
            data.category === 'duration-of-illness'
              ? data
              : data?.value || '----'
        }
      } else {
        return undefined
      }
    })
    .filter(data => data !== undefined)
}

export const DiagnosisTableColumnsData = (t, data) => [
  {
    label: t('Description'),
    value: data?.codeDescription
  },
  {
    label: t('Type'),
    headerCellClass: data?.codeId
  }
]

export const supportInfoValuesColumnsData = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' },
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'category',
    header: t('Category'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'code',
    header: t('Code'),
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('value'),
    headerCellClass: '!bg-gray-200',
    body: rowData => {
      if (rowData?.image_data) {
        const handleDownloadFile = () => {
          const byteCharacters = atob(rowData?.image_data?.image_value)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], {
            type: rowData?.image_data?.image_content_type
          })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.href = url
          a.download = rowData?.image_data?.image_title
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)

          URL.revokeObjectURL(url)
        }
        return (
          <div className='flex items-center gap-4'>
            <img
              className='h-[100px] w-[100px] rounded-md'
              src={`data:image/png;base64,${rowData?.image_data?.image_value}`}
            />
            <FaCloudDownloadAlt
              size={20}
              className='text-gray cursor-pointer'
              onClick={handleDownloadFile}
            />
          </div>
        )
      } else if (rowData?.category === 'chief-complaint') {
        return extractTextFromHTML(rowData?.value)
      } else {
        return rowData?.value
      }
    }
  }
]

export const emrDiagnosisHeaders = [
  'description',
  'codeId',
  'type',
  'on_admission'
]

export const formatDiagnosisData = diagnosisData => {
  return diagnosisData?.map(data => {
    let description = data?.codeDescription
    let codeId = data?.codeId
    let type = data?.type
    let on_admission = data?.on_admission
    return {
      description,
      codeId,
      type,
      on_admission
    }
  })
}

export const emrItemsHeaders = [
  'ItemCode',
  'Name',
  'Route',
  'Frequency',
  'DaysSupply',
  'Dosage',
  'Instructions',
  'Quantity'
  // 'ApprovalStatus',
  // 'ApprovalNo'
]

export const fomrateEMRItemsData = itemsData => {
  return itemsData?.map(data => {
    let ItemCode = data?.non_standard_code || '---'
    let Name = data?.non_standard_description || '---'
    let Route = data?.route || '---'
    let Frequency = data?.frequency || '---'
    let DaysSupply = data?.days_supply || '---'
    let Dosage = data?.dosage || '---'
    let Instructions = data?.instructions || '---'
    let Quantity = data?.quantity || '---'
    // let ApprovalStatus = data?.approval_status || '---'
    // if (data?.approval_status === 'rejected' && data?.rejection_reason) {
    //   ApprovalStatus += ` (${data.rejection_reason})`
    // }
    // let ApprovalNo = data?.approval_number || '---'
    return {
      ItemCode,
      Name,
      Route,
      Frequency,
      DaysSupply,
      Dosage,
      Instructions,
      Quantity
      // ApprovalStatus,
      // ApprovalNo
    }
  })
}
export const fomrateEMRItemsDataPrescription = itemsData => {
  return itemsData
    ?.filter(it => it?.selected_category === 'medication-codes')
    ?.map(data => {
      let ItemCode = data?.non_standard_code || '---'
      let Name = data?.non_standard_description || '---'
      let Route = data?.route || '---'
      let Frequency = data?.frequency || '---'
      let DaysSupply = data?.days_supply || '---'
      let Instructions = data?.instructions || '---'
      let Dosage = data?.dosage || '---'
      return {
        ItemCode,
        Name,
        Route,
        Frequency,
        DaysSupply,
        Dosage,
        Instructions
      }
    })
}
export const emrAccidentHeaders = ['Type', 'Date', 'City', 'State']

export const emrAccidentValues = accidentdata => {
  return accidentdata?.map(data => {
    let Type = data?.accidentType
    let Date = formatDateTime(data?.date)
    let City = data?.city
    let State = data?.state
    return {
      Type,
      Date,
      City,
      State
    }
  })
}

export const viewEmrItemData = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' },
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'item_name',
    header: t('Name'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'standard_code',
    header: t('StandardCode'),
    headerCellClass: '!bg-gray-200'
  },
  {
    field: 'non_standard_code',
    header: t('NonStandardCode'),
    headerCellClass: '!bg-gray-200'
  },
  { field: 'item_type', header: t('Type'), headerCellClass: '!bg-gray-200' }
]

export const VitalSignsRecordList = (data, t) => {
  const vitalMap = data?.reduce((acc, obj) => ({ ...acc, ...obj }), {}) || {}
  console.log(vitalMap)

  return [
    {
      label: t('vital_sign_systolic'),
      text: vitalMap['vital-sign-systolic']
        ? `${vitalMap['vital-sign-systolic']} mmHg`
        : '--'
    },
    {
      label: t('vital_sign_diastolic'),
      text: vitalMap['vital-sign-diastolic']
        ? `${vitalMap['vital-sign-diastolic']} mmHg`
        : '--'
    },
    {
      label: t('vital_sign_height'),
      text: vitalMap['vital-sign-height']
        ? `${vitalMap['vital-sign-height']} cm`
        : '--'
    },
    {
      label: t('vital_sign_weight'),
      text: vitalMap['vital-sign-weight']
        ? `${vitalMap['vital-sign-weight']} kg`
        : '--'
    },
    {
      label: t('temperature'),
      text: vitalMap['vital-sign-temperature']
        ? `${vitalMap['vital-sign-temperature']} °C`
        : '--'
    },
    {
      label: t('RR'),
      text: vitalMap['vital-sign-respiratory-rate']
        ? `${vitalMap['vital-sign-respiratory-rate']} mir`
        : '--'
    },
    {
      label: t('pulse'),
      text: vitalMap['vital-sign-pulse']
        ? `${vitalMap['vital-sign-pulse']} mir`
        : '--'
    },
    {
      label: t('SPO2'),
      text: vitalMap['vital-sign-SP02']
        ? `${vitalMap['vital-sign-SP02']} %`
        : '--'
    },
    {
      label: t('rbs'),
      text: vitalMap['vital-sign-RBS']
        ? `${vitalMap['vital-sign-RBS']} mg/dL`
        : '--'
    },
    {
      label: t('pain_score'),
      text: vitalMap['vital-sign-pain-score'] || '--'
    },
    {
      label: t('Duration of Illness'),
      text: formatDuration(vitalMap['duration-of-illness'], t) || '--'
    }
  ]
}

export const EncounterData = data => [
  {
    label: 'Class',
    text: data?.encounterClass || '--'
  },
  {
    label: 'Priority',
    text: data?.encounterPriority || '--'
  }
]

export const AccidentData = data => [
  {
    label: 'Type',
    text: data?.accidentType || '--'
  },
  {
    label: 'Admin Source',
    text: data?.adminSource || '--'
  }
]

export const excludedSupportingInfoCategories = [
  'vital-sign-systolic',
  'vital-sign-diastolic',
  'vital-sign-height',
  'vital-sign-weight',
  'respiratory-rate',
  'temperature',
  'pulse',
  'SP02',
  'RBS',
  'pain-score',
  'chief-complaint'
]

export function convertPreAuthClinicalData(inputData, emrCreationDate = null) {
  let excludedCategories = [
    'SP02',
    'RBS',
    'pain-score',
    'vital-sign-bmi',
    'bmi'
  ]
  return inputData
    ?.map(item => {
      if (excludedCategories?.includes(item?.category)) return undefined

      let finalValue
      let finalReason

      if (item?.category === 'chief-complaint') {
        const extractedText = extractTextFromHTML(item?.value)
        const hasValue = extractedText && extractedText.trim() !== ''
        finalValue = hasValue ? extractedText : null
        finalReason = hasValue ? null : item?.reason || null
      } else {
        const hasValue =
          item?.value !== null &&
          item?.value !== undefined &&
          item?.value !== ''
        finalValue = hasValue ? String(item?.value) : null
        finalReason = hasValue ? null : item?.reason || null
      }

      const baseObject = {
        category: item?.category,
        code: item?.code || null,
        code_text: item?.code_text || item?.codeText || null,
        start_date: item?.start_date || emrCreationDate || null,
        end_date: item?.end_date || null,
        value: finalValue,
        unit: item?.valueUnit || item?.unit || null,
        reason: finalReason,
        image_content_type:
          item?.image_content_type !== undefined
            ? item?.image_content_type
            : item?.imageContentType || item?.image?.contentType || null,
        image_title:
          item?.image_title !== undefined
            ? item?.image_title
            : item?.imageTitle || item?.image?.title || null,
        image_creation_date:
          item?.image_creation_date !== undefined
            ? item?.image_creation_date
            : item?.imageCreationDate || item?.image?.creationDate || null,
        image_value:
          item?.image_value !== undefined
            ? item?.image_value
            : item?.imageValue || item?.image?.value || null,
        image_minio_path:
          item?.image_minio_path !== undefined
            ? item?.image_minio_path
            : item?.imageMinioPath || item?.image?.minioPath || null
      }

      if (item?.category === 'chief-complaint') {
        baseObject.code = item?.code || '297272000'
      }

      if (item?.category === 'vital-sign-temperature') {
        baseObject.category = 'temperature'
      }
      if (item?.category === 'vital-sign-respiratory-rate') {
        baseObject.category = 'respiratory-rate'
      }

      if (item?.category === 'vital-sign-pulse') {
        baseObject.category = 'pulse'
      }
      if (item?.category === 'vital-sign-SP02') {
        baseObject.category = 'oxygen-saturation'
      }

      if (item?.category?.startsWith('vital-sign-')) {
        baseObject.code = null
        baseObject.code_text = null
      }

      if (
        item?.category === 'vital-sign-pain-score' ||
        item?.category === 'vital-sign-RBS' ||
        item?.category === 'duration-of-illness'
      ) {
        return null
      }

      return baseObject
    })
    .filter(Boolean)
}

export const progressNotesTabs = (t, isNurse) => {
  return [
    ...(!isNurse
      ? [
        {
          name: t('progress_notes'),
          content: (
            <ProgressNotesEditor
              type='progress_notes'
              placeholder={`${t('Add')} ${t('progress_notes')}`}
            />
          )
        },
        {
          name: t('Recommendation'),
          content: (
            <ProgressNotesEditor
              type='recommendation'
              placeholder={`${t('Add')} ${t('recommendation')}`}
            />
          )
        },
        {
          name: t('history_and_physical'),
          content: (
            <ProgressNotesEditor
              type='history_notes'
              placeholder={`${t('Add')} ${t('history_and_physical')}`}
            />
          )
        },
        {
          name: t('consult_notes'),
          content: (
            <ProgressNotesEditor
              type='consult_notes'
              placeholder={`${t('Add')} ${t('consult_notes')}`}
            />
          )
        },
        {
          name: t('procedure_notes'),
          content: (
            <ProgressNotesEditor
              type='procedure_notes'
              placeholder={`${t('Add')} ${t('procedure_notes')}`}
            />
          )
        }
      ]
      : []),
    {
      name: t('nursing_notes'),
      content: (
        <ProgressNotesEditor
          type='nursing_notes'
          placeholder={`${t('Add')} ${t('nursing_notes')}`}
        />
      )
    }
  ]
}

export const medicalAssesmentsTabs = t => {
  return [
    {
      name: t('chief_complaints'),
      content: (
        <ProgressNotesEditor
          type='chiefComplaints.value'
          placeholder={`${t('Add')} ${t('chief_complaints')}`}
        />
      )
    },
    {
      name: t('significant_signs'),
      content: (
        <ProgressNotesEditor
          type='significantSign'
          placeholder={`${t('Add')} ${t('significant_signs')}`}
        />
      )
    },
    {
      name: t('other_condition'),
      content: (
        <ProgressNotesEditor
          type='otherCondition'
          placeholder={`${t('Add')} ${t('other_condition')}`}
        />
      )
    },
    {
      name: t('physical_assesment'),
      content: (
        <ProgressNotesEditor
          type='physical_assesment'
          placeholder={`${t('Add')} ${t('physical_assesment')}`}
        />
      )
    },
    {
      name: t('past_history'),
      content: (
        <ProgressNotesEditor
          type='past_history'
          placeholder={`${t('Add')} ${t('past_history')}`}
        />
      )
    },
    {
      name: t('family_history'),
      content: (
        <ProgressNotesEditor
          type='family_history'
          placeholder={`${t('Add')} ${t('family_history')}`}
        />
      )
    }
  ]
}

export const emrPatientDetailsList = (emrData, t) => {
  return [
    [
      { content: `${t('Patient Name')} / اسم المريض:`, bold: true },
      { content: emrData?.patient?.full_name || '-', bold: false },
      { content: `${t('DOB')} / تاريخ الميلاد:`, bold: true },
      { content: formatDate(emrData?.patient?.dob), bold: false }
    ],
    [
      { content: `${t('DocumentId')} / معرف المستند:`, bold: true },
      { content: emrData?.patient?.document_id || '-', bold: false },
      { content: `${t('MRN')} / رقم الملف الطبي:`, bold: true },
      { content: emrData?.patient?.file_no, bold: false }
    ],
    [
      { content: `${t('Gender')} / الجنس:`, bold: true },
      { content: emrData?.patient?.gender || '-', bold: false },
      { content: `${t('nationality')} / الجنسية:`, bold: true },
      { content: emrData?.patient?.nationality || '-', bold: false }
    ],
    [
      { content: `${t('Practitioner')} / ممارس:`, bold: true },
      {
        content: emrData?.careTeamsArr?.[0]?.practitionerName || '-',
        bold: false
      },
      { content: `${t('Role')} / دور:`, bold: true },
      {
        content: emrData?.careTeamsArr?.[0]?.care_team_role || '-',
        bold: false
      }
    ]
  ]
}

export const emrPatientPracDetailsList = (emrData, t) => {
  return [
    [
      { content: `${t('Patient Name')} / اسم المريض:`, bold: true },
      { content: emrData?.patient?.full_name || '-', bold: false },
      { content: `${t('DOB')} / تاريخ الميلاد:`, bold: true },
      { content: formatDate(emrData?.patient?.dob), bold: false },
      { content: `${t('DocumentId')} / معرف المستند:`, bold: true },
      { content: emrData?.patient?.document_id || '-', bold: false }
    ],
    [
      { content: `${t('MRN')} / رقم الملف الطبي:`, bold: true },
      { content: emrData?.patient?.file_no, bold: false },
      { content: `${t('Gender')} / الجنس:`, bold: true },
      { content: emrData?.patient?.gender || '-', bold: false },
      { content: `${t('nationality')} / الجنسية:`, bold: true },
      { content: emrData?.patient?.nationality || '-', bold: false }
    ],

    [
      { content: `${t('Practitioner')} / ممارس:`, bold: true },
      {
        content: emrData?.careTeamsArr?.[0]?.practitionerName || '-',
        bold: false
      }
    ]
  ]
}

export const routeOptions = [
  {
    label: 'Oral - فموي',
    value: 'oral'
  },
  {
    label: 'Intravenous (IV) - وريدِي',
    value: 'intravenous'
  },
  {
    label: 'Intramuscular (IM) - عضلي',
    value: 'intramuscular'
  },
  {
    label: 'Subcutaneous (SC) - تحت الجلد',
    value: 'subcutaneous'
  },
  {
    label: 'Topical - موضعي',
    value: 'topical'
  },
  {
    label: 'Transdermal - عبر الجلد',
    value: 'transdermal'
  },
  {
    label: 'Inhalation - استنشاقي',
    value: 'inhalation'
  },
  {
    label: 'Intranasal - أنفي',
    value: 'intranasal'
  },
  {
    label: 'Sublingual - تحت اللسان',
    value: 'sublingual'
  },
  {
    label: 'Buccal - خدِّي',
    value: 'buccal'
  },
  {
    label: 'Rectal - شرجي',
    value: 'rectal'
  },
  {
    label: 'Vaginal - مهبلي',
    value: 'vaginal'
  },
  {
    label: 'Ophthalmic - عيني',
    value: 'ophthalmic'
  },
  {
    label: 'Otic - أذني',
    value: 'otic'
  },
  {
    label: 'Intrathecal - داخل القراب',
    value: 'intrathecal'
  },
  {
    label: 'Epidural - فوق الجافية',
    value: 'epidural'
  },
  {
    label: 'Intradermal - داخل الجلد',
    value: 'intradermal'
  },
  {
    label: 'Enteral (via tube) - معوي',
    value: 'enteral'
  },
  {
    label: 'Nasal - أنفي',
    value: 'nasal'
  },
  {
    label: 'Urethral - إحليلي',
    value: 'urethral'
  },
  {
    label: 'Dermal - جلدي',
    value: 'dermal'
  }
]

export const frequencyOptionss = [
  {
    label: 'Once daily - مرة يوميًا',
    value: 'once_daily'
  },
  {
    label: 'Twice daily - مرتين يوميًا',
    value: 'twice_daily'
  },
  {
    label: 'Three times daily - ثلاث مرات يوميًا',
    value: 'three_times_daily'
  },
  {
    label: 'Four times daily - أربع مرات يوميًا',
    value: 'four_times_daily'
  },
  {
    label: 'Every 6 hours - كل 6 ساعات',
    value: 'every_6_hours'
  },
  {
    label: 'Every 8 hours - كل 8 ساعات',
    value: 'every_8_hours'
  },
  {
    label: 'Every 12 hours - كل 12 ساعة',
    value: 'every_12_hours'
  },
  {
    label: 'Every other day - يوم بعد يوم',
    value: 'every_other_day'
  },
  {
    label: 'Once weekly - مرة أسبوعيًا',
    value: 'once_weekly'
  },
  {
    label: 'As needed - عند الحاجة',
    value: 'as_needed'
  },
  {
    label: 'Before meals - قبل الوجبات',
    value: 'before_meals'
  },
  {
    label: 'After meals - بعد الوجبات',
    value: 'after_meals'
  },
  {
    label: 'At bedtime - وقت النوم',
    value: 'at_bedtime'
  },
  {
    label: 'Every morning - كل صباح',
    value: 'every_morning'
  },
  {
    label: 'Every night - كل مساء',
    value: 'every_night'
  },
  {
    label: 'Hourly - كل ساعة',
    value: 'hourly'
  },
  {
    label: 'Stat (Immediately) - فورًا',
    value: 'stat'
  }
]

export const FavoriteItems = []
